import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Switch,
    FormControlLabel,
    Typography,
    Grid,
    IconButton,
    Paper,
    Box,
    Checkbox,
    FormGroup,
    Divider,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import InputMask from 'react-input-mask';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ListaUsuarios from './ListaUsuarios';
import flaskServer from '../config/flaskserver';

// Módulos disponíveis no sistema
export const MODULOS_SISTEMA = [
    { key: 'conciliar', label: 'Conciliar (provisionamento, dois arquivos, auxiliar)' },
    { key: 'cadastros_tiss', label: 'Cadastros TISS / Conciliação TISS' },
    { key: 'configuracoes', label: 'Configurações' },
    { key: 'admin', label: 'Administração de Usuários' },
    { key: 'logs', label: 'Visualizar Logs' },
    { key: 'suporte', label: 'Suporte / Contato' },
];

const FormInput = styled(TextField)({
    margin: '8px',
    width: '100%',
});

const SubmitButton = styled(Button)(({ theme }) => ({
    margin: '16px',
    width: '100%',
}));

const CadastroUsuario = ({ isUserAdminn, handleLogout }) => {
    const [formVisible, setFormVisible] = useState(false);
    const [username, setUsername] = useState('');
    const [nomeEmpresa, setNomeEmpresa] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [senhaRepetida, setSenhaRepetida] = useState('');
    const [numAccessesAllowed, setNumAccessesAllowed] = useState(1);
    const [isAdminUser, setIsAdminUser] = useState(false);
    const [users, setUsers] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [validade, setValidade] = useState('');
    const [status, setStatus] = useState(true);
    const [is_email_verified, setIsEmailVerified] = useState(false);
    const [modulos, setModulos] = useState([]);

    useEffect(() => {
        fetchUsers();
    }, []);

    // Se o usuário for admin, libera tudo automaticamente
    useEffect(() => {
        if (isAdminUser) {
            setModulos(MODULOS_SISTEMA.map(m => m.key));
        }
    }, [isAdminUser]);

    const handleModuloChange = (key) => {
        setModulos(prev =>
            prev.includes(key) ? prev.filter(m => m !== key) : [...prev, key]
        );
    };

    const fetchUsers = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${flaskServer.flaskServerIP}/users`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.status === 401) { handleLogout(); return; }
            setUsers(response.data.users);
        } catch (error) { }
    };

    const handleRegister = async () => {
        if (password !== senhaRepetida) {
            setPasswordError('As senhas não coincidem.');
            return;
        }
        setPasswordError('');

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(`${flaskServer.flaskServerIP}/register`, {
                username,
                nomeEmpresa,
                celular,
                email,
                password,
                isAdmin: isAdminUser,
                numAccessesAllowed,
                validade,
                status,
                is_email_verified,
                modulos,
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.status === 401) { handleLogout(); return; }

            // Limpar após registro
            setUsername(''); setNomeEmpresa(''); setCelular(''); setEmail('');
            setPassword(''); setSenhaRepetida(''); setIsAdminUser(false);
            setNumAccessesAllowed(1); setValidade(''); setStatus(true);
            setModulos([]);

            fetchUsers();
            setFormVisible(false);
        } catch (error) { }
    };

    const handlePasswordVisibility = () => setShowPassword(!showPassword);

    return (
        <div>
            {isUserAdminn && (
                <>
                    {!formVisible && (
                        <Button variant="contained" color="primary" onClick={() => setFormVisible(true)}>
                            Cadastrar Usuário
                        </Button>
                    )}

                    {formVisible && (
                        <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
                            <Typography variant="h6" gutterBottom>Cadastro de Usuário</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <FormInput label="Seu Nome" value={username} onChange={(e) => setUsername(e.target.value)} required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormInput label="Nome da Empresa" value={nomeEmpresa} onChange={(e) => setNomeEmpresa(e.target.value)} required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <InputMask mask="(99) 99999-9999" value={celular} onChange={(e) => setCelular(e.target.value)}>
                                        {(inputProps) => <FormInput {...inputProps} label="Celular" required />}
                                    </InputMask>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormInput label="E-mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormInput
                                        label="Defina uma Senha"
                                        type={showPassword ? 'text' : 'password'}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton edge="end" onClick={handlePasswordVisibility}>
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            ),
                                        }}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormInput
                                        label="Repita a Senha"
                                        type={showPassword ? 'text' : 'password'}
                                        value={senhaRepetida}
                                        onChange={(e) => setSenhaRepetida(e.target.value)}
                                        error={!!passwordError}
                                        helperText={passwordError}
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton edge="end" onClick={handlePasswordVisibility}>
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            ),
                                        }}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={<Switch checked={isAdminUser} onChange={(e) => setIsAdminUser(e.target.checked)} name="isAdmin" color="primary" />}
                                        label="É admin (acesso total)"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={<Switch checked={is_email_verified} onChange={(e) => setIsEmailVerified(e.target.checked)} name="is_email_verified" color="primary" />}
                                        label="E-mail Verificado"
                                    />
                                </Grid>

                                {/* ── Módulos liberados ── */}
                                <Grid item xs={12}>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                                        Módulos liberados
                                    </Typography>
                                    {isAdminUser && (
                                        <Typography variant="caption" color="primary" sx={{ display: 'block', mb: 1 }}>
                                            Administrador tem acesso a todos os módulos automaticamente.
                                        </Typography>
                                    )}
                                    <FormGroup row>
                                        {MODULOS_SISTEMA.map((modulo) => (
                                            <FormControlLabel
                                                key={modulo.key}
                                                sx={{ width: '100%', mb: 0.5 }}
                                                control={
                                                    <Checkbox
                                                        checked={modulos.includes(modulo.key)}
                                                        onChange={() => handleModuloChange(modulo.key)}
                                                        color="primary"
                                                        disabled={isAdminUser}
                                                    />
                                                }
                                                label={modulo.label}
                                            />
                                        ))}
                                    </FormGroup>
                                    <Divider sx={{ mt: 1 }} />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <FormInput
                                        type="number"
                                        label="Número de acessos simultâneos permitidos"
                                        value={numAccessesAllowed}
                                        onChange={(e) => setNumAccessesAllowed(Number(e.target.value))}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormInput
                                        type="date"
                                        label="Validade"
                                        value={validade}
                                        onChange={(e) => setValidade(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={<Switch checked={status} onChange={(e) => setStatus(e.target.checked)} name="status" color="primary" />}
                                        label="Status"
                                    />
                                </Grid>
                            </Grid>
                            <Box display="flex" justifyContent="space-between" marginTop={2}>
                                <Button variant="contained" color="secondary" onClick={() => setFormVisible(false)}>
                                    Cancelar
                                </Button>
                                <SubmitButton variant="contained" color="primary" onClick={handleRegister}>
                                    Registrar
                                </SubmitButton>
                            </Box>
                        </Paper>
                    )}

                    <ListaUsuarios users={users} setUsers={setUsers} />
                </>
            )}

            {!isUserAdminn && (
                <Typography variant="h6" color="error">
                    Você não tem permissão para acessar esta página.
                </Typography>
            )}
        </div>
    );
};

export default CadastroUsuario;
